import { useEffect, useMemo, useState } from "react";
import { Search } from "lucide-react";
import { api, asArray } from "../lib/api";
import { PageHero } from "../components/site/PageHero";
import { BlogCard } from "../components/site/BlogCard";
import { Reveal } from "../components/site/Reveal";

export default function Blogs() {
  const [blogs, setBlogs] = useState(null);
  const [cat, setCat] = useState("All");
  const [q, setQ] = useState("");

  useEffect(() => {
    api.get("/blogs").then((r) => setBlogs(asArray(r))).catch(() => setBlogs([]));
  }, []);

  const cats = useMemo(() => ["All", ...new Set((blogs || []).map((b) => b.category).filter(Boolean))], [blogs]);
  const list = (blogs || []).filter(
    (b) => (cat === "All" || b.category === cat) && `${b.title} ${b.excerpt}`.toLowerCase().includes(q.toLowerCase())
  );

  return (
    <>
      <PageHero testid="blogs-hero" eyebrow="Insights" lines={["Regulation,", <span className="font-serif-i text-[var(--brass-deep)]">read closely.</span>]} intro="Practical notes on SEBI circulars, audits, inspections and compliance practice for market intermediaries." />
      <section className="bg-paper py-16 sm:py-24 min-h-[50vh]">
        <div className="mx-auto max-w-[1400px] px-5 sm:px-8 lg:px-12">
          <div className="flex flex-col md:flex-row gap-6 md:items-center justify-between mb-14">
            <div className="flex flex-wrap gap-2" data-testid="blog-category-filter">
              {cats.map((c) => (
                <button key={c} data-testid={`blog-filter-${c.toLowerCase().replace(/\s+/g, "-")}`} onClick={() => setCat(c)}
                  className={`rounded-full px-4 py-2 text-sm font-medium border transition-colors duration-300 ${cat === c ? "bg-ink text-paper border-ink" : "border-ink/25 hover:border-ink"}`}>
                  {c}
                </button>
              ))}
            </div>
            <label className="flex items-center gap-3 border-b border-ink/30 focus-within:border-ink py-2 md:w-72">
              <Search className="w-4 h-4 text-ink/60" />
              <input data-testid="blog-search-input" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search insights" className="bg-transparent outline-none flex-1 text-sm placeholder:text-ink/50" />
            </label>
          </div>
          {blogs && !list.length && <p data-testid="blogs-empty" className="py-20 text-center font-serif-i text-2xl text-ink/60">No articles found.</p>}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-14">
            {list.map((b, i) => <Reveal key={b.id} delay={(i % 3) * 0.08}><BlogCard blog={b} index={i} /></Reveal>)}
          </div>
        </div>
      </section>
    </>
  );
}
